<template>
  <b-navbar toggleable="lg" type="dark" class="navbar apl">
    <b-navbar-brand href="#">CTP 문제은행</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item href="#" @click.prevent="bookmgr()">교재관리</b-nav-item>
        <b-nav-item href="#" @click.prevent="intentmgr()"
          >출제포인트 관리</b-nav-item
        >
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-form>
          <b-form-input
            size="sm"
            class="mr-sm-2"
            placeholder="Search"
          ></b-form-input>
          <b-button size="sm" class="my-2 my-sm-0" type="submit"
            >지식찾기</b-button
          >
        </b-nav-form> -->

        <!-- <b-nav-item-dropdown text="Lang" right>
          <b-dropdown-item href="#">EN</b-dropdown-item>
          <b-dropdown-item href="#">ES</b-dropdown-item>
          <b-dropdown-item href="#">RU</b-dropdown-item>
          <b-dropdown-item href="#">FA</b-dropdown-item>
        </b-nav-item-dropdown> -->
        <b-nav-item href="#" @click="labs">LABS</b-nav-item>
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content> {{ user_id }}</template>
          <b-dropdown-item href="#" @click.prevent="profile"
            >Profile</b-dropdown-item
          >
          <b-dropdown-item href="#" @click.prevent="logout"
            >Sign Out</b-dropdown-item
          >
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  data() {
    return {
      user_id: this.$cookies.get("user_id"),
    };
  },
  methods: {
    bookmgr() {
      this.$router.push("/admin/book/list");
    },
    intentmgr() {
      this.$router.push("/admin/intent/list");
    },
    profile() {
      this.$router.replace("/profile");
    },
    logout() {
      this.$cookies.remove("user_id");
      this.$cookies.remove("token");
      this.$router.replace("/login");
    },
    labs() {
      this.$router.push("/admin/labs/list");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.navbar {
  background-color: $gray600;
}
.apl {
  background-color: $color1;
}
</style>